import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';

//-- Actions
import { getProductByPage, setStorePosition } from './../StoreActions';

//-- Common
import Zigzag from './../../../containers/UI/Common/Shapes/Zigzag';

//-- Containers
import ProductContainer from './../../../containers/Product/ProductContainer';
class ProductsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstInitDimension: true,
            productWidth:0,
            productMarginLeft:0,
            productContainerWidth:0,
            marginToCenterTarget:0,
            refs : []
        }
        this.wantSwipe = false;
        this.oldClientX = 0;
    }

    /*****************************
     * Override component methods *
     *****************************/
    componentDidMount = () => {
        //- Get all product from API (take first page)
        this.props.getProducts(1);

        //- Add listener on resize
        window.addEventListener('resize', this.initDimension);

        let productListContainer = ReactDOM.findDOMNode(this.refs['list-container']);
            productListContainer.classList.add('no-anim'); // disable transition animation by default
     
        //- When we back to Details view, we need to keep last focused object
        if ( this.props.products.length > 0 && this.state.firstInitDimension ) {
            
            this.setState({firstInitDimension : false}, () => {
                this.initDimension();
            })
        }

    }

    componentDidUpdate(prevProps) {
        
        // it is used only when product loaded throught XHR request are updated (so during the first init of the app)
        if(prevProps.products.length < this.props.products.length){
     
            let productListContainer = ReactDOM.findDOMNode(this.refs['list-container']);
            if(productListContainer.classList.contains('no-anim')){
                productListContainer.classList.remove('no-anim');
            }
            
            // force to redraw carousel dimension
            this.initDimension();
        } 
    }

    componentWillUnmount = () => {
        //- Remove listener on resize
        window.removeEventListener('resize', this.initDimension);

    }

    /*************************
     *         Handler       *
     *************************/
    handlerProductClicked = (e) => {
        const targetIndex = parseInt(e.target.getAttribute("data-index"), 10);
        
        let productListContainer = ReactDOM.findDOMNode(this.refs['list-container']);
        if(productListContainer.classList.contains('no-anim')){
            productListContainer.classList.remove('no-anim');
        }

        //-- Change product focused if is not current position of producd
        if ( targetIndex !== this.props.position ) {
            this.props.setStorePosition(targetIndex);
            return;
        }

        //-- Need to display details
        this.props.popDetailsShow();
    }

    /*************************
     *    Custom carousel    *
     *************************/

     /**
      * initialising all informations about pages for carousel
      */
    initDimension = () => {
        const products = document.getElementsByClassName("product")
        let productWidth = 0;
        let productMarginLeft = 0;
        if ( products.length > 0 ) {
            productWidth = products[0].offsetWidth;
            const _productMarginLeft = window.getComputedStyle(products[0], null).getPropertyValue('margin-left');
            productMarginLeft = parseInt(_productMarginLeft.substring(0, _productMarginLeft.length - 2), 10); //- need to remove "px" value at the end
        }

        const productContainer = document.getElementsByClassName("products-container")[0];
        const productContainerWidth = productContainer.offsetWidth;

        const marginToCenterTarget = Math.floor(( productContainerWidth - productMarginLeft*2 - productWidth ) / 2);
        
       

        this.setState({
            productWidth,
            productContainerWidth,
            productMarginLeft,
            marginToCenterTarget
        });
    }

    /*************************
     *     Swip listeners    *
     ************************/

    bindTouchEvents() {
        return {
            onTouchMove: e => {
                this.direction = this.oldClientX - e.touches[0].clientX;
                this.oldClientX = e.touches[0].clientX;
            },
            onTouchEnd: this.bindCommonUp,
            onTouchCancel: this.bindCommonUp
        }
    }

    bindMouseEvents() {
        return {
            onMouseDown: e => {
                this.wantSwipe = true;
            },
            onMouseMove: e => {
                if ( this.wantSwipe ) {
                    this.direction = this.oldClientX - e.clientX;
                    this.oldClientX = e.clientX;

                }
            },
            onMouseUp: this.bindCommonUp,
            onMouseLeave: this.bindCommonUp
        };
    }

    bindCommonUp = (e) => {
        this.wantSwipe = false;
        //- Swipe to left
        if ( this.direction < 0 ) {
            if ( this.props.position > 0 ) {
                this.props.setStorePosition(this.props.position - 1);
            }
        } else //- Swipe to right
        if ( this.direction > 0 ) {
            if ( this.props.position + 1 < this.props.products.length ) {
                this.props.setStorePosition(this.props.position +1);
            }
        }
        //-- Reset direction
        this.direction = 0;
    }

    render = () => {
        //-- calc marginLeft product on on each render
        const marginLeftProductsContainer = this.state.marginToCenterTarget - this.props.position * ( this.state.productWidth + this.state.productMarginLeft );

        return <div 
                    className="wrapper-products-container"
                    {...this.bindTouchEvents()}
                    {...this.bindMouseEvents()}>
                    <div 
                        className="products-container" ref="list-container"
                        style={{
                            marginLeft: marginLeftProductsContainer,
                        }}>
                        {/* ProductContainer */}
                        {
                            this.props.products.map((product, key) => {
                                const classes = ["product"];
                                
                                if ( key === this.props.position ) {
                                    classes.push("focused");
                                }
                                return <ProductContainer 
                                            className={classes}
                                            key={`product-containerid-${key}`}
                                            title={product.title}
                                            img={product.img_url}
                                            price={product.price}
                                            description={product.content_html}

                                            productIndex={key}
                                            
                                            onClick={this.handlerProductClicked}/>
                            })
                        }
                    </div>
                    <div className="shape shape-top">
                        <Zigzag color="#ffde39" translateXaxis="-10" />
                    </div>
                    <div className="shape shape-bottom">
                        <Zigzag color="#fd8598" translateXaxis="10" />
                    </div>
                </div>;
                
    }
}

const mapStateToProps = state => {
    return {
        products: state.datasStore.products,
        position: state.datasStore.targetedProduct
    }
};

const mapStateToDispatch = dispatch => {
    return {
        'getProducts' : (page) => { dispatch(getProductByPage(page)) },
        'setStorePosition' : ( newPosition ) => { dispatch(setStorePosition( newPosition ))}

    }
}

export default connect( mapStateToProps, mapStateToDispatch )(ProductsList);


// WEBPACK FOOTER //
// ./src/components/StorePage/ProductList/ProductList.js